export default __webpack_public_path__ + "static/media/blue-background.6bb9b0ac.svg";